export const honeypotFieldName = "hp_field"

type HoneypotInputProps = {
  readonly ref?: React.Ref<HTMLInputElement>
}

export function HoneypotInput({ ref }: HoneypotInputProps) {
  return (
    <input
      aria-hidden="true"
      autoComplete="off"
      className="fixed top-0 left-[-9999px] h-0 w-0 overflow-hidden"
      data-testid="honeypot-field"
      name={honeypotFieldName}
      ref={ref}
      tabIndex={-1}
      type="text"
    />
  )
}
